module.exports = __webpack_public_path__ + "2cb7274025034949bb0980965a30c6a8.svg";